
import axios from 'axios'
import { getToken } from './auth'
import { Message } from 'view-design'

// 创建axios实例
const service = axios.create({
  timeout: 10000, // 请求超时时间
  autoMsg: true
})

// request拦截器
service.interceptors.request.use(config => {
  const token = getToken()
  const newConfig = Object.assign({}, config)
  if (token) {
    newConfig.headers.Authorization = token
  }
  return newConfig
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    let errMsg = ''
    if (res.code === 500) {
      const msgKey = Object.keys(res.data)[0]
      errMsg = (res.data && res.data[msgKey]) || '服务器错误'
    } else if (res.code !== 200) {
      errMsg = res.message || '网络问题'
    }
    if (typeof errMsg === 'string' && errMsg.trim().toLowerCase() === 'signature is invalid') {
      errMsg = '无权限'
    }
    // 错误提示
    const config = response.config
    if (errMsg && config.autoMsg) {
      Message.error(errMsg)
    }
    return response.data
  },
  error => {
    Message.error('数据错误')
    return Promise.reject(error)
  }
)

export default service
